import Gallery from "./Gallery";

const UnderTheSea = () => (
  <Gallery imageNames={["under the sea-01.png", "under the sea-02.png"]} />
);
export default UnderTheSea;
